/**
 * @fileoverview Colors theme - match colored heart and shape emojis.
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

/**
 * Colors theme for learning colors with hearts and shapes.
 */
export class ColorsTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'colors',
            'Colors',
            allLabels.colors,
            { numPairs: 3, isPremium: false, hasMovement: false, ...options }
        );
    }
}
